import React from "react";

const Contactlist = React.memo(function Contactlist({ customer, handleSelectCustomer }) {
  if (!customer) return null;

  return (
    <tr key={customer.id} className={customer.selected ? "table-active" : ""}>
      {/* Show checkbox column only if handleSelectCustomer exists */}
      {handleSelectCustomer && (
        <td width="50" className="text-center align-middle">
          <div className="form-check d-flex justify-content-center align-items-center mb-0">
            <input
              type="checkbox"
              className="form-check-input cursor-pointer"
              id={`customer-${customer.id}`}
              checked={Boolean(customer.selected)}
              onChange={() => handleSelectCustomer(customer.id)}
            />
          </div>
        </td>
      )}

      <td className="align-middle fw-medium">{customer.name || 'Unknown'}</td>
      <td className="align-middle text-nowrap">{customer.mobile || customer.phone_number || '-'}</td>
      <td className="align-middle text-muted">{customer.email || '-'}</td>
      <td className="align-middle">
        <span className="badge bg-light text-dark border">{customer.tag || customer.city || 'Contact'}</span>
      </td>
    </tr>
  );
}, areEqual);

function areEqual(prevProps, nextProps) {
  return (
    prevProps.customer?.selected === nextProps.customer?.selected &&
    prevProps.customer?.id === nextProps.customer?.id &&
    prevProps.customer?.name === nextProps.customer?.name &&
    prevProps.customer?.mobile === nextProps.customer?.mobile &&
    prevProps.customer?.email === nextProps.customer?.email &&
    prevProps.customer?.tag === nextProps.customer?.tag &&
    prevProps.handleSelectCustomer === nextProps.handleSelectCustomer
  );
}

export default Contactlist;